import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  Popover,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Paper,
  Container,
  Typography,
  Button,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TablePagination,
  TableRow,
  TableCell,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  RadioGroup,
  Radio,
  FormControlLabel,
  Alert,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Lottie from "react-lottie-player";
import ChatLottie from "../../../img/ChatBotLottie.json";
import { AntTabs, AntTab } from "../../Separaciones/tabs_style";
import { useMediaQuery } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { ContextSession } from "../../../services/ContextSession";
import { Link } from "react-router-dom";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SocialDistanceIcon from "@mui/icons-material/SocialDistance";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none",
    borderLeft: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#C1C1C1",
  },
}));

const TablaVerConversaciones = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [tabIndex, setTabIndex] = React.useState(0);
  const navigate = useNavigate();
  let sessi = useContext(ContextSession);
  const [filas, setFilas] = useState([]); // Estado para guardar todos los datos
  const [filteredRows, setFilteredRows] = useState([]); // Estado para guardar los datos filtrados
  const [loading, setLoading] = useState(true);
  const [agentes, setAgentes] = useState({});
  const [agenteFiltro, setAgenteFiltro] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openReassignDialog, setOpenReassignDialog] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const [currentRowAgentId, setCurrentRowAgentId] = useState("");
  const [currentRowId, setCurrentRowId] = useState(null);
  const [reassignError, setReassignError] = useState("");
  const [agentNameToConfirm, setAgentNameToConfirm] = useState("");
  const [openDialogExito, setOpenDialogExito] = useState(false);

  /*useEffect(() => {
        const fetchAgentes = async () => {
            try {
                const response = await fetch('https://chatbot.injupemp.gob.hn/obtener_agentes/');
                const data = await response.json();
                const agentesMap = {};
                data.agentes.forEach(agente => {
                    agentesMap[agente.id] = agente.nombre;
                });
                setAgentes(agentesMap);
            } catch (error) {
                console.error('Error al cargar los agentes:', error);
            }
        };

        fetchAgentes();
    }, []);*/

  const [agentesFiltro, setAgentesFiltro] = useState([]);

  useEffect(() => {
    const fetchAgentes = async () => {
      try {
        const response = await fetch(
          "https://chatbot.injupemp.gob.hn/obtener_agentes/"
        );
        const data = await response.json();

        const agentesMap = {};
        data.agentes.forEach((agente) => {
          agentesMap[agente.id] = agente.nombre; // Guardar todos los agentes en el estado
        });

        setAgentes(agentesMap);

        // Filtrar los agentes prohibidos solo para el Select
        const agentesPermitidos = data.agentes.filter(
          (agente) =>
            !["Victor Sierra", "Kelin Ferrera", "Martha Triminio"].includes(
              agente.nombre
            )
        );

        setAgentesFiltro(agentesPermitidos); // Nuevo estado para el Select
      } catch (error) {
        console.error("Error al cargar los agentes:", error);
      }
    };

    fetchAgentes();
  }, []);

  /*useEffect(() => {
        const fetchTickets = async () => {
            try {
                const response = await fetch('https://chatbot.injupemp.gob.hn/obtener_tickets/');
                const data = await response.json();
                setFilas(data.tickets || []); // Guardar todos los tickets en el estado
            } catch (error) {
                console.error('Error al cargar los tickets:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTickets();
    }, []);*/

  useEffect(() => {
    const fetchTickets = async () => {
      setLoading(true);

      try {
        // Seleccionar la URL dependiendo del tab
        let url = "";
        if (tabIndex === 0) {
          url = "https://chatbot.injupemp.gob.hn/obtener_tickets_activos/";
        } else {
          url = "https://chatbot.injupemp.gob.hn/obtener_tickets/";
        }

        const response = await fetch(url);
        const data = await response.json();

        const filteredTickets = data.tickets.filter((ticket) => {
          return ![
            "Victor Sierra",
            "Kelin Ferrera",
            "Martha Triminio",
          ].includes(agentes[ticket.agente_asignado]);
        });

        setFilas(filteredTickets);
      } catch (error) {
        console.error("Error al cargar los tickets:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, [tabIndex, agentes]); // Se ejecuta al cambiar el tab o los agentes

  const [searchID, setSearchID] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchDNI, setSearchDNI] = useState("");

  useEffect(() => {
    const filtered = filas.filter((row) => {
      const estadoFiltro =
        tabIndex === 0
          ? row.estado.toLowerCase() === "en proceso" ||
            row.estado.toLowerCase() === "pendiente"
          : row.estado.toLowerCase() !== "en proceso" &&
            row.estado.toLowerCase() !== "pendiente";

      const agenteFiltroAplicado = agenteFiltro
        ? row.agente_asignado == agenteFiltro
        : true;

      const idMatch = searchID
        ? row.id
          ? row.id.toString().includes(searchID)
          : false
        : true;
      const nameMatch = searchName
        ? row.nombre.toLowerCase().includes(searchName.toLowerCase())
        : true;
      const dniMatch = searchDNI
        ? row.dni
          ? row.dni.toString().includes(searchDNI)
          : false
        : true;

      return (
        estadoFiltro && agenteFiltroAplicado && idMatch && nameMatch && dniMatch
      );
    });

    const sorted = filtered.sort(
      (a, b) => new Date(b.fecha_inicio) - new Date(a.fecha_inicio)
    );
    setFilteredRows(sorted);
  }, [filas, tabIndex, agenteFiltro, searchID, searchName, searchDNI]);

  const handleSearchIDChange = (event) => setSearchID(event.target.value);
  const handleSearchNameChange = (event) => setSearchName(event.target.value);
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTabChange = (event, newValue) => setTabIndex(newValue);

  const handleClick = (id) => {
    sessi.setVariable("SolicitudChatbot", id);
    navigate("/PortalDelParticipante/VerConsultaChatBotJefe");
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const handleOpenReassignDialog = (rowId, currentAgentId) => {
    console.log(
      "Current agent ID:",
      currentAgentId,
      "Type:",
      typeof currentAgentId
    );
    setCurrentRowId(rowId);
    setCurrentRowAgentId(currentAgentId);
    setSelectedAgentId("");
    setReassignError("");
    setOpenReassignDialog(true);
  };

  const handleCloseReassignDialog = () => {
    setOpenReassignDialog(false);
  };

  const handleReassignConfirm = () => {
    if (!selectedAgentId) {
      setReassignError("Debe seleccionar un agente");
      return;
    }

    // Buscar el nombre del agente seleccionado
    const selectedAgentName = agentes[selectedAgentId];
    setAgentNameToConfirm(selectedAgentName);
    setOpenConfirmDialog(true);
  };

  const handleFinalReassign = async () => {
    try {
      const response = await fetch(
        "https://chatbot.injupemp.gob.hn/reasignar_ticket/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ticket_id: currentRowId,
            nuevo_agente_id: selectedAgentId,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Actualizar el estado local
        const updatedRows = filas.map((row) =>
          row.id === currentRowId
            ? { ...row, agente_asignado: selectedAgentId }
            : row
        );
        setFilas(updatedRows);
        setOpenReassignDialog(false);
        setOpenConfirmDialog(false);
        setOpenDialogExito(true); // Mostrar diálogo de éxito
      } else {
        setReassignError(data.error || "Error al reasignar");
        setOpenConfirmDialog(false);
      }
    } catch (error) {
      setReassignError("Error de conexión");
      console.error("Error:", error);
      setOpenConfirmDialog(false);
    }
  };

  // Reiniciar la página al cambiar el término de búsqueda
  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
    setPage(0); // Reinicia la página a la primera
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Container style={{ marginTop: 15 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            Conversaciones de Agentes en INJUPEMP VIRTUAL
          </Typography>
        </div>

        <Box display="flex" justifyContent="center" alignItems="center">
          <Lottie
            loop
            animationData={ChatLottie}
            play
            style={{ width: "10%", height: "auto" }}
          />
        </Box>

        <Container>
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 5,
            }}
          >
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { display: "none" } }}
              >
                <AntTab
                  label="Consultas Activas"
                  sx={{ textDecoration: tabIndex === 0 ? "underline" : "none" }}
                />
                <AntTab
                  label="Consultas Cerradas"
                  sx={{ textDecoration: tabIndex === 1 ? "underline" : "none" }}
                />
              </AntTabs>
            </Paper>
          </Box>
        </Container>
      </Container>

      <div className="row" style={{ marginTop: "20px" }}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="300px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography variant="subtitle1" gutterBottom>
              Filtrar por agente:
            </Typography>
            <FormControl
              fullWidth
              style={{ marginBottom: "15px", maxWidth: "300px" }}
            >
              <Select
                value={agenteFiltro}
                onChange={(event) => setAgenteFiltro(event.target.value)}
                displayEmpty
              >
                <MenuItem value="">Todos</MenuItem>
                {agentesFiltro.map((agente) => (
                  <MenuItem key={agente.id} value={agente.id}>
                    {agente.nombre.toUpperCase()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TableContainer component={Paper}>
              <Table style={{ fontSize: isMobile ? "7px" : "14px" }}>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <div>
                        <strong>ID Solicitud</strong>
                        <Tooltip title="Buscar por ID Solicitud" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "searchID")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <div>
                        <strong>Nombre</strong>
                        <Tooltip title="Buscar por Nombre" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "search")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <div>
                        <strong>Número de Identidad</strong>
                        <Tooltip title="Buscar por DNI" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "searchDNI")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>{" "}
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Teléfono</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Teléfono Alterno</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Fecha Solicitud</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Agente Asignado</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Estado</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Acciones</strong>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableBody>
                  {filteredRows.length === 0 ? (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={9}
                        style={{ textAlign: "center", fontSize: 17 }}
                      >
                        {tabIndex === 0
                          ? "No hay solicitudes activas"
                          : "No hay solicitudes cerradas"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    filteredRows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => (
                        <StyledTableRow key={row.id}>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.id}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.nombre.toUpperCase()}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.dni}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.telefono}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.telefono_alterno ?? "NA"}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.fecha_inicio
                              ? new Date(row.fecha_inicio).toLocaleString()
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {agentes[row.agente_asignado]
                              ? agentes[row.agente_asignado].toUpperCase()
                              : "SIN ASIGNAR"}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.estado.toUpperCase()}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <div
                              className="action-buttons"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Link
                                onClick={() => handleClick(row.id)}
                                title="Ir Al Chat"
                                style={{ color: "#10ab80", margin: "0 5px" }}
                              >
                                <i className="material-icons">&#xE417;</i>
                              </Link>
                              {tabIndex === 0 && (
                                <button
                                  onClick={() =>
                                    handleOpenReassignDialog(
                                      row.id,
                                      row.agente_asignado
                                    )
                                  }
                                  title="Reasignar Usuario"
                                  style={{
                                    color: "grey",
                                    margin: "0 5px",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="material-icons">group_add</i>
                                </button>
                              )}
                            </div>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleFilterClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              {filterType === "search" && (
                <TextField
                  placeholder="Buscar por Nombre"
                  variant="outlined"
                  value={searchName}
                  onChange={handleSearchNameChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              {filterType === "searchID" && (
                <TextField
                  placeholder="Buscar por ID"
                  variant="outlined"
                  value={searchID}
                  onChange={handleSearchIDChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              {filterType === "searchDNI" && (
                <TextField
                  placeholder="Buscar por DNI"
                  variant="outlined"
                  value={searchDNI}
                  onChange={handleSearchDNIChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            </Popover>
          </>
        )}

        {!loading && filteredRows.length > 0 && (
          <TablePagination
            rowsPerPageOptions={isMobile ? [3, 5, 10] : [15, 20, 30]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={isMobile ? "Filas:" : "Filas por página"}
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count}`
            }
          />
        )}
      </div>

      {/* Diálogo de Reasignación */}
      <Dialog
        open={openReassignDialog}
        onClose={handleCloseReassignDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px", // Bordes más redondeados
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", // Sombra más pronunciada
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "primary.main",
            color: "white",
            fontWeight: "bold",
            py: 2,
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1, // Esto añade un pequeño espacio entre el texto y el icono
          }}
        >
          <SocialDistanceIcon sx={{ color: "white", fontSize: 40 }} /> Reasignar
          Agente <SocialDistanceIcon sx={{ color: "white", fontSize: 40 }} />
        </DialogTitle>

        <DialogContent sx={{ py: 3 }}>
          <DialogContentText
            sx={{
              mb: 2,
              color: "text.secondary",
              fontSize: "0.95rem",
              marginTop: 1,
            }}
          >
            Seleccione el nuevo agente para esta conversación:
          </DialogContentText>

          <RadioGroup
            value={selectedAgentId}
            onChange={(e) => setSelectedAgentId(e.target.value)}
            sx={{
              "& .MuiFormControlLabel-root": {
                mx: 0,
                mb: 1,
                borderRadius: "8px",
                transition: "background-color 0.2s",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
                "&.Mui-disabled": {
                  opacity: 0.6,
                  backgroundColor: "action.disabledBackground",
                },
              },
              "& .MuiRadio-root": {
                color: "primary.main",
                "&.Mui-checked": {
                  color: "red",
                },
              },
              "& .MuiTypography-root": {
                fontWeight: 500,
                color: "text.primary",
                display: "flex",
                alignItems: "center",
                gap: 1, // Espacio entre icono y texto
              },
            }}
          >
            {Object.entries(agentes)
              .filter(
                ([id, nombre]) =>
                  ![
                    "Victor Sierra",
                    "Kelin Ferrera",
                    "Martha Triminio",
                  ].includes(nombre)
              )
              .map(([id, nombre]) => (
                <FormControlLabel
                  key={id}
                  value={id}
                  control={<Radio />}
                  label={
                    <>
                      <SupportAgentIcon sx={{ color: "grey", fontSize: 30 }} />
                      {nombre.toUpperCase()}
                    </>
                  }
                  disabled={id.toString() === currentRowAgentId?.toString()}
                  sx={{
                    backgroundColor:
                      id.toString() === currentRowAgentId?.toString()
                        ? "grey.100"
                        : "transparent",
                  }}
                />
              ))}
          </RadioGroup>

          {reassignError && (
            <Alert
              severity="error"
              sx={{
                mt: 2,
                borderRadius: "8px",
                "& .MuiAlert-icon": {
                  alignItems: "center",
                },
              }}
            >
              {reassignError}
            </Alert>
          )}
        </DialogContent>

        <DialogActions
          sx={{ px: 3, py: 2, borderTop: "1px solid", borderColor: "divider" }}
        >
          <Button onClick={handleCloseReassignDialog} color="error">
            Cancelar
          </Button>
          <Button
            onClick={handleReassignConfirm}
            color="primary"
            variant="contained"
            sx={{
              fontWeight: "bold",
              borderRadius: "8px",
              px: 3,
              boxShadow: "none",
              textTransform: "none",
              "&:hover": {
                boxShadow: "none",
                backgroundColor: "primary.dark",
              },
            }}
          >
            Confirmar Reasignación
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Confirmación */}
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirmar Reasignación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea reasignar este ticket a {agentNameToConfirm}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="primary">
            No
          </Button>
          <Button
            onClick={handleFinalReassign}
            color="primary"
            variant="contained"
          >
            Sí, confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de confirmación */}
      <Dialog open={openDialogExito} onClose={() => setOpenDialogExito(false)}>
        <DialogTitle>Reasignación Exitosa</DialogTitle>
        <DialogContent>
          <DialogContentText>
            El agente ha sido reasignado con éxito.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDialogExito(false)}
            color="primary"
            autoFocus
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TablaVerConversaciones;
